import { ButtonHTMLAttributes, ReactNode } from 'react';

import { cls } from '@/utils/cls';

type IconButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  children: ReactNode;
};

export function IconButton({ children, className, ...props }: IconButtonProps) {
  const base =
    'cursor-pointer text-gray-400 hover:text-gray-600 inline-flex items-center justify-center rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-[#274483] hover:bg-gray-100';

  return (
    <button type="button" className={cls(base, className)} {...props}>
      {children}
    </button>
  );
}
